$(function() {
	var set = function () {
		var width = (window.innerWidth > 0) ? window.innerWidth : this.screen.width;
		var topOffset = 55;
		if (width < 1170) {
			$('.navbar-brand span').hide();
			$(".sidebartoggler i").addClass("ti-menu");
		}
		else {
			$('.navbar-brand span').show();
		}
		var height = ((window.innerHeight > 0) ? window.innerHeight : this.screen.height) - 1;
		height = height - topOffset;
		if (height < 1) height = 1;
		if (height > topOffset) {
			$(".page-wrapper").css("min-height", (height) + "px");
		}
	};
	$(window).ready(set);
	$(window).on("resize", set);
});